var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"unset compare-icon text-right",on:{"click":_vm.addProductToCompare}},[_c('i',{staticClass:"material-icons"},[_vm._v("compare_arrows")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780d9181","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/product-compare.vue
// module id = yGx+
// module chunks = 0